// components/admin/spaces/SpaceForm.jsx
import {
    DynamicInputSelect,
    InputCheckBox,
    InputEmail,
    InputText,
    InputTextArea,
} from '../../../utils/dynamicForm';
import { DynamicInputMultiSelect } from '../../../utils/dynamicExtraForm';
import { InputImagesBlock } from '../../../utils/imageTools';
import { LocationPicker } from '../../../utils/LocationPicker';
import { Spinner, Message } from '../../index';

const FormRow = ({ children }) => <div className="form-row-2cols">{children}</div>;

export default function SpaceForm({
                                      edit,
                                      formCleanHandler,
                                      isLoading,
                                      isError,
                                      register,
                                      errors,
                                      watch,
                                      isLoadingUpdate,
                                      isLoadingPost,
                                      handleSubmit,
                                      submitHandler,
                                      error,
                                      setValue,
                                      t,
                                      images_path,
                                      setFileInputs,
                                      fileInputs,
                                      control,
                                      formRef
                                  }) {
    const openingsOptions = [
        {value: 'bars', label: 'Κάγκελα'},
        {value: 'door', label: 'Πόρτα'},
        {value: 'window', label: 'Παράθυρο'},
    ];
    const accessOptions = [
        {value: 'secured', label: 'Ασφαλισμένο'},
        {value: 'climb', label: 'Ημιπροσβασιμο'},
        {value: 'openings', label: 'Διάτρητα ανοίγματα'},
    ];
    const coatingConditionOptions = [
        {value: 'intact', label: 'Βιώσιμη'},
        {value: 'partial', label: 'Μερεμέτια'},
        {value: 'collapsed', label: 'Γκρεμισμένο'},
    ];
    const coatingMaterialOptions = [
        {value: 'lime', label: 'Ασβέστης'},
        {value: 'clay', label: 'Άργυλος'},
        {value: 'other', label: 'Άλλο'},
    ];
    const wallsConditionOptions = [
        {value: 'intact', label: 'Βιώσιμη'},
        {value: 'partial', label: 'Μερεμέτια'},
        {value: 'collapsed', label: 'Γκρεμισμένο'},
    ];
    const wallsMaterialOptions = [
        {value: 'stone', label: 'Πέτρα'},
        {value: 'mudbrick', label: 'Πλιθί'},
        {value: 'brick', label: 'Τούβλο'},
        {value: 'other', label: 'Άλλο'}
    ];
    const roofMaterialOptions = [
        {value: 'ceramic_tiles', label: 'Κεραμίδι'},
        {value: 'stone', label: 'Πέτρα'},
        {value: 'concrete_slab', label: 'Πλάκα μπετόν'},
        {value: 'other', label: 'Άλλο'}
    ];
    const roofConditionOptions = [
        {value: 'intact', label: 'Βιώσιμη'},
        {value: 'partial', label: 'Μερεμέτια'},
        {value: 'collapsed', label: 'Γκρεμισμένο'},
    ];
    const includesOptions = [
        {value: 'yard', label: 'Αυλή'},
        {value: 'trees', label: 'Δέντρα'},
        {value: 'historical', label: 'Αρχαία'},
    ];
    const buildingTypeOptions = [
        {value: 'shop', label: 'Μαγαζί'},
        {value: 'plot', label: 'Οικόπεδο'},
        {value: 'residence', label: 'Οικία'},
        {value: 'public', label: 'Δημόσιο'},
        {value: 'other', label: 'Άλλο'},
    ];
    const squareMetersOptions = [
        {value: '100', label: '100'},
        {value: '101_200', label: '101-200'},
        {value: '201_300', label: '201-300'},
        {value: '301_500', label: '301-500'},
        {value: '501_1000', label: '501-1000'},
        {value: '1000+', label: '1000+'}
    ];

    const initialLat = watch('lat');
    const initialLng = watch('lng');

    return (
        <div className='admin-space-editor admin-panel-editor' data-mode={edit ? 'edit' : 'create'}>
            <div className='d-flex justify-content-end gap-2 mb-3'>
                <button
                    type='button'
                    className='btn btn-secondary'
                    onClick={formCleanHandler}
                >
                    {t('Close')}
                </button>
                <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => formRef.current?.requestSubmit()}
                    disabled={isLoadingPost || isLoadingUpdate}
                >
                    {isLoadingPost || isLoadingUpdate ? (
                        <span className='spinner-border spinner-border-sm'/>
                    ) : t('Save')}
                </button>
            </div>

            {isLoading ? (
                <Spinner/>
            ) : isError ? (
                <Message variant='danger'>{error}</Message>
            ) : (
                <form ref={formRef} onSubmit={handleSubmit(submitHandler)}>
                    <div className='basic-data form-group-block'>
                        <div className='basic-data-title form-group-title'>{t("ΓΕΝΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ")}</div>
                        {InputText({
                            register,
                            errors,
                            label: 'Όνομα / Τίτλος / ID',
                            name: 'name',
                            placeholder: '',
                            isRequired: true
                        })}
                        <div className="form-row-2cols">
                            {InputTextArea({
                                register,
                                errors,
                                label: 'Περιγραφή του Χώρου',
                                name: 'description',
                                placeholder: "",
                                isRequired: false
                            })}
                            {InputTextArea({
                                register,
                                errors,
                                label: 'Extra Notes',
                                name: 'extraNotes',
                                placeholder: '',
                                isRequired: false
                            })}
                        </div>
                        {InputImagesBlock({
                            setValue,
                            errors,
                            watch,
                            register,
                            label: 'Images',
                            name: 'images',
                            placeholder: 'Max Size 10MB',
                            isRequired: false,
                            images_path,
                            fileInputs,
                            setFileInputs,
                            maxImages: 5,
                            t
                        })}
                        <FormRow>
                            {DynamicInputSelect({
                                register,
                                errors,
                                label: 'Square Meters',
                                name: 'squareMeters',
                                placeholder: "select",
                                isRequired: false,
                                data: squareMetersOptions,
                                value: 'label',
                                id: 'value',
                                icons: false
                            })}
                            {InputText({
                                register,
                                errors,
                                label: 'Όροφοι',
                                name: 'floors',
                                placeholder: '',
                                isRequired: false
                            })}
                        </FormRow>

                        <FormRow>
                            <DynamicInputMultiSelect
                                control={control} errors={errors} label='Building Type' name='building_type'
                                placeholder='select' isRequired={false} data={buildingTypeOptions} value='label'
                                icons={false} id='building_type' t={t}
                            />
                            <DynamicInputMultiSelect
                                control={control} errors={errors} label='Includes' name='includes'
                                placeholder='select' isRequired={false} data={includesOptions} value='label'
                                icons={false} id='includes' t={t}
                            />
                        </FormRow>
                    </div>

                    <div className='form-group-block'>
                        <div className='form-group-title'>{t("Roof")}</div>
                        <FormRow>
                            <DynamicInputMultiSelect
                                control={control} errors={errors} label='Roof Material' name='roof.material'
                                placeholder='select' isRequired={false} data={roofMaterialOptions} value='label'
                                icons={false} id='roof_material' t={t}
                            />
                            {DynamicInputSelect({
                                register,
                                errors,
                                label: 'Roof Condition',
                                name: 'roof.condition',
                                placeholder: "select",
                                isRequired: false,
                                data: roofConditionOptions,
                                value: 'label',
                                id: 'value',
                                icons: false
                            })}
                        </FormRow>
                    </div>

                    <div className='form-group-block'>
                        <div className='form-group-title'>{t('Masonry')}</div>
                        <FormRow>
                            <DynamicInputMultiSelect
                                control={control} errors={errors} label='Walls Material' name='walls.material'
                                placeholder='select' isRequired={false} data={wallsMaterialOptions} value='label'
                                icons={false} id='walls_material' t={t}
                            />
                            {DynamicInputSelect({
                                register,
                                errors,
                                label: 'Walls Condition',
                                name: 'walls.condition',
                                placeholder: "select",
                                isRequired: false,
                                data: wallsConditionOptions,
                                value: 'label',
                                id: 'value',
                                icons: false
                            })}
                        </FormRow>
                        <FormRow>
                            <DynamicInputMultiSelect
                                control={control} errors={errors} label='Coating Material' name='coating.material'
                                placeholder='select' isRequired={false} data={coatingMaterialOptions} value='label'
                                icons={false} id='coating_material' t={t}
                            />
                            {DynamicInputSelect({
                                register,
                                errors,
                                label: 'Coating Condition',
                                name: 'coating.condition',
                                placeholder: "select",
                                isRequired: false,
                                data: coatingConditionOptions,
                                value: 'label',
                                id: 'value',
                                icons: false
                            })}
                        </FormRow>
                    </div>

                    <div className='form-group-block'>
                        <div className='form-group-title'>{t("Accessibility")}</div>
                        <FormRow>
                            <DynamicInputMultiSelect
                                control={control} errors={errors} label='Type of Openings' name='openings'
                                placeholder='select' isRequired={false} data={openingsOptions} value='label'
                                icons={false} id='type_of_openings' t={t}
                            />
                            <DynamicInputMultiSelect
                                control={control} errors={errors} label='Access' name='access'
                                placeholder='select' isRequired={false} data={accessOptions} value='label'
                                icons={false} id='type_of_access' t={t}
                            />
                        </FormRow>
                        <FormRow>
                            {InputTextArea({
                                register,
                                errors,
                                label: 'Access Description',
                                name: 'access',
                                placeholder: '',
                                isRequired: false
                            })}
                        </FormRow>
                    </div>

                    <div className='address-data form-group-block'>
                        <div className='address-data-title form-group-title'>{t("ΣΤΟΙΧΕΙΑ ΔΙΕΥΘΥΝΣΗΣ")}</div>
                        <FormRow>
                            {InputText({
                                register,
                                errors,
                                label: 'Διεύθυνση',
                                name: 'address',
                                placeholder: '',
                                isRequired: false
                            })}
                            {InputText({
                                register,
                                errors,
                                label: 'ΤΚ',
                                name: 'postal',
                                placeholder: '',
                                isRequired: false
                            })}
                        </FormRow>
                    </div>

                    <div className='location-data form-group-block'>
                        <div className='location-data-title form-group-title'>{t("GPS DATA")}</div>
                        {LocationPicker({
                            register, errors, watch, setValue, isRequired: false, placeholder: "",
                            initialLat, initialLng
                        })}
                    </div>

                    <div className='contact-data form-group-block'>
                        <FormRow>
                            <div className='contact-data-title form-group-title'>{t("ΣΤΟΙΧΕΙΑ ΕΠΙΚΟΙΝΩΝΙΑΣ")}</div>
                            {InputText({
                                register,
                                errors,
                                label: 'Τηλέφωνο Επικοινωνίας',
                                name: 'phone',
                                placeholder: '',
                                isRequired: false
                            })}
                            {InputEmail({
                                register,
                                errors,
                                label: 'Email',
                                name: 'email',
                                placeholder: '',
                                isRequired: false
                            })}
                        </FormRow>
                    </div>

                    {InputCheckBox({
                        register,
                        errors,
                        watch,
                        name: 'confirmed',
                        label: 'Confirmed',
                        isRequired: false,
                        placeholder: 'Confirmed'
                    })}
                    {InputCheckBox({
                        register,
                        errors,
                        watch,
                        name: 'blocked',
                        label: 'Blocked',
                        isRequired: false,
                        placeholder: 'Blocked'
                    })}
                    {InputCheckBox({
                        register,
                        errors,
                        watch,
                        name: 'under_review',
                        label: 'Under Review',
                        isRequired: false,
                        placeholder: 'Under Review'
                    })}

                    <div className='d-flex justify-content-end gap-2 mt-3'>
                        <button type='button' className='btn btn-secondary'
                                onClick={formCleanHandler}>{t('Close')}</button>
                        <button type='submit' className='btn btn-primary' disabled={isLoadingPost || isLoadingUpdate}>
                            {isLoadingPost || isLoadingUpdate ?
                                <span className='spinner-border spinner-border-sm'/> : t('Save')}
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
}
